import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

const AuthMiddleware = ({ children }) => {
  const location = useLocation()
  const isAuthenticated = !!localStorage.getItem('authUser')

  const publicPaths = ['/login', '/forgot-password']
  const isResetPasswordRoute = location.pathname.startsWith('/reset-password')

  if (!isAuthenticated && !publicPaths.includes(location.pathname) && !isResetPasswordRoute) {
    return <Navigate to='/login' state={{ from: location }} />
  }

  return <>{children}</>
}

export default AuthMiddleware
